<script>
  import { Tooltip } from "paxray-components-svelte";

  export let process;
  export let groupType;
  export let groupColor;
  export let index = 0;
  export let processCardIcon;
  export let coreKpis;
  export let onProcessClick = () => {};
</script>

<button
  type="button"
  class="process-card"
  class:core-card={groupType === "core"}
  style={`--group-color: ${groupColor}`}
  on:click={() => onProcessClick(process)}
  title={`Open ${process.name} in Process Catalog`}
>
  {#if groupType === "core"}
    <div class="process-identity core-identity">
      <img src={`/img/assistant/icons/${processCardIcon(index, groupType)}.svg`} alt="" />
      <strong>{process.name}</strong>
    </div>
    {#if process.has_kpis !== false}
      <div class="kpi-list">
        {#each coreKpis(process) as kpi}
          <div class="kpi-row">
            <span>{kpi.label}{#if kpi.tooltip} <Tooltip text={kpi.tooltip} />{/if}</span>
            <strong class:na-value={kpi.value === "N/A"}>{kpi.value}</strong>
          </div>
        {/each}
      </div>
    {:else}
      <div class="kpi-empty"><strong class="na-value">N/A</strong><span>No measured KPIs yet</span></div>
    {/if}
  {:else}
    <div class="process-identity simple-identity">
      <img src={`/img/assistant/icons/${processCardIcon(index, groupType)}.svg`} alt="" />
      <strong>{process.name}</strong>
    </div>
    {#if process.has_kpis !== false}
      <div class="kpi-list">
        {#each coreKpis(process).filter((kpi) => ["General Score", "Activity"].includes(kpi.label)) as kpi}
          <div class="kpi-row">
            <span>{kpi.label}</span>
            <strong class:na-value={kpi.value === "N/A"}>{kpi.value}</strong>
          </div>
        {/each}
      </div>
    {/if}
  {/if}
</button>

<style>
  .process-card { display: flex; min-width: 0; min-height: 7rem; flex-direction: column; justify-content: space-between; overflow: hidden; padding: 0; border: 1px solid #000; border-radius: 0.35rem; background: #fff; text-align: left; cursor: pointer; }
  .core-card { min-height: 21rem; }
  .process-identity { border-bottom: 1px solid var(--pax-black); background: var(--group-color); }
  .core-identity { display: flex; min-height: 0; flex-direction: column; align-items: center; justify-content: center; gap: 0.45rem; padding: 1rem; color: #202329; text-align: center; }
  .process-identity img { filter: brightness(0); }
  .core-identity img { width: 2.5rem; height: 2.5rem; }
  .core-identity strong { display: -webkit-box; overflow: hidden; color: var(--pax-black); font-size: 0.75rem; line-height: 1.2; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
  .simple-identity { display: flex; min-height: 0; flex-direction: column; align-items: center; justify-content: center; gap: 0.55rem; padding: 1rem; text-align: center; }
  .simple-identity img { width: 2rem; height: 2rem; opacity: 0.72; }
  .simple-identity strong { display: -webkit-box; overflow: hidden; color: var(--pax-black); font-size: 0.75rem; line-height: 1.2; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
  .kpi-list { display: grid; grid-template-columns: 1fr; flex: 1; width: 100%; background: #fff; }
  .kpi-empty { display: grid; flex: 1; width: 100%; place-items: center; gap: 0.25rem; padding: 1rem; background: #fff; color: var(--pax-black); font-size: 0.68rem; }
  .kpi-row { display: grid; grid-template-columns: minmax(0, 1fr) auto; align-items: center; gap: 2rem; min-height: 2rem; padding: 0.5rem 0.65rem; border-bottom: 1px solid #dce3e6; }
  .kpi-row:last-child { border-bottom: 0; }
  .kpi-row strong { overflow: hidden; color: var(--pax-black); font-size: 0.75rem; text-align: right; text-overflow: ellipsis; white-space: nowrap; }
  .kpi-row > span { display: inline-flex; align-items: center; gap: 0.25rem; color: var(--pax-black); font-size: 0.7rem; }
  .na-value { color: #da1e28; font-weight: 700; text-transform: none; }
</style>
